import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_myRoutesModule.css'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import MyRoutes from './MyRoutes'
import BookmarkedRoutes from './BookmarkedRoutes'

export default class MyRoutesModule extends Component {

  static propTypes = {
    name: PropTypes.string,
    onSelect: PropTypes.func,
  }

  state = {
    active: 0,
  }

  handleNav = (i) => () => {
    this.setState({ active: i })
  }

  render () {

    return (
      <div className={styles.container}>
        <nav className={styles.nav}>
          <div
            onClick={this.handleNav(0)}
            className={classnames(styles.navItem, {
              [styles.active]: this.state.active === 0,
            })}
          >
            <FormattedMessage
              id='routes.my_routes_module.my_routes'
              defaultMessage='My Routes'
            />
          </div>
          <div
            onClick={this.handleNav(1)}
            className={classnames(styles.navItem, {
              [styles.active]: this.state.active === 1,
            })}
          >
            <FormattedMessage
              id='routes.my_routes_module.bookmarked_routes'
              defaultMessage='Bookmarked Routes'
            />
          </div>
        </nav>

        {this.state.active === 0 ?
          <MyRoutes onSelect={this.props.onSelect} />
        : null}

        {this.state.active === 1 ?
          <BookmarkedRoutes onSelect={this.props.onSelect} />
        : null}

      </div>
    )
  }
}

